<template>
<div class="chapter">
<div class="inner_page">
<p class="ded" id="d7e2016"><span><i>To my daughters,</i><br/>
<i>Laurel and Deshanna</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Morg_9781550924589_epub_c4_r1.vue?e17efb68